(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // Contact form: a native POST + full page load, so the only feedback until the
  // next page arrives is this. Delegated on document so it survives theme-editor
  // section re-renders. A second submit while busy is swallowed (double send).
  //
  // Shopify's hCaptcha cancels every submit event, runs the check, then posts
  // with the native form.submit() — which fires no submit event, so the guard
  // never blocks the real send. If the challenge is dismissed nothing is posted
  // and no page comes, so busy gives up after BUSY_MS rather than lock the button.
  const BUSY_MS = 8000;
  const clearBusy = (button) => {
    clearTimeout(button.dpBusyTimer);
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  };
  document.addEventListener('submit', (event) => {
    const button = event.target.closest?.('.dp-contact__form')?.querySelector('.dp-contact__submit');
    if (!button) return;
    if (button.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    button.dpBusyTimer = setTimeout(() => clearBusy(button), BUSY_MS);
  });
  // back/forward cache restores the page as it was left — busy — so reset it
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.dp-contact__submit[aria-busy]').forEach(clearBusy);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('dp-copy-link')) {
    customElements.define(
      'dp-copy-link',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          const status = this.querySelector('[role="status"]');
          if (!button) return;
          if (!navigator.clipboard) {
            this.hidden = true;
            return;
          }
          // success = the link icon turns into a check mark (text only for screen
          // readers); failure = a short visible message under the button
          const say = (text, ok) => {
            status.textContent = text;
            this.classList.toggle('is-copied', ok);
            this.classList.toggle('is-failed', !ok);
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              status.textContent = '';
              this.classList.remove('is-copied', 'is-failed');
            }, 2500);
          };
          button.addEventListener('click', () => {
            navigator.clipboard
              .writeText(this.dataset.url)
              .then(() => say(this.dataset.copied, true))
              .catch(() => say(this.dataset.failed, false));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
